import React from 'react';

import Image from 'next/image';
import { AvatarPerfilSVG } from '../../../utils/icons';
import {
    BoxEnderecoAnunciante,
    BoxInformacoesAnunciante,
    BoxNomeAnuncianteTexto,
    FotoAnunciante,
} from './infoAnunciante-styled';

const InfoAnunciante = ({ urlLogo, nome, cep, enderecoAnunciante }) => {
    return (
        <>
            <BoxInformacoesAnunciante>
                <FotoAnunciante hasImage={!!urlLogo}>
                    <Image
                        alt="logo do anunciante"
                        src={urlLogo ? urlLogo : AvatarPerfilSVG}
                        layout={'fill'}
                        objectFit={'contain'}
                    />
                </FotoAnunciante>
                <BoxNomeAnuncianteTexto>
                    <p>Anunciante</p>
                    <h3>{nome}</h3>
                </BoxNomeAnuncianteTexto>
            </BoxInformacoesAnunciante>

            <BoxEnderecoAnunciante>
                {cep && (
                    <span>
                        CEP: {cep}
                        <br />
                    </span>
                )}
                <span>{enderecoAnunciante}</span>
            </BoxEnderecoAnunciante>
        </>
    );
};

export default InfoAnunciante;
